import classNames from "classnames";
import { DetailedHTMLProps } from "react";

type LabelProps = {
  position?: "top" | "bottom" | "left" | "right";
  text: string;
  labelClass?: string;
  htmlFor?: string;
} & DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

function Label({
  children,
  position,
  text,
  className,
  labelClass,
  htmlFor,
  ...props
}: LabelProps) {
  const getLabelPosition = () => {
    switch (position) {
      case "top":
        return "flex flex-col";
      case "bottom":
        return "flex flex-col-reverse";
      case "right":
        return "flex flex-row-reverse justify-end";
      case "left":
      default:
        return "flex flex-row";
    }
  };

  return (
    <div
      {...props}
      className={classNames(
        className,
        `${getLabelPosition()}`,
        "text-nid_black",
      )}
    >
      <label htmlFor={htmlFor} className={classNames(labelClass)}>
        {text}
      </label>
      <div>{children}</div>
    </div>
  );
}

export default Label;
